import React, { Component } from 'react'
import './Xloading.scss';
export default class Xloading extends Component {
  getSpotUI = ()=>{
    let elements = [];
    for (let i = 0; i < 36; i++) {
      elements.push(<div className='spot' key={'spot'+i}></div>);
    }
    return elements;
  }

  render() {
    return (
      <div className="loading">
        {
          this.getSpotUI()
        }
      </div>
    )
  }
}